import { HashRouter, Routes, Route } from "react-router-dom";
import HomePage from "./HomePage";
import Orders from "../Orders";
import Address from "../Addresses";
import PaymentMethods from "../PaymentMethods";
import CustomerBookings from "../CustomerBookings";
import WineClubSubscriptions from "../WineClubSubscriptions";
import SubscriptionList from "../Subscriptions/SubscriptionList";

const Account = () => {
	return (
		<HashRouter basename="/">
			<div className="flex flex-col">
				<Routes>
					<Route path="/" element={<HomePage />} />
					<Route path="/orders" element={<Orders />} />
					<Route path="/address" element={<Address />} />
					<Route path="/payment/methods" element={<PaymentMethods />} />
					<Route path="/my-events" element={<CustomerBookings />} />
					<Route path="/subscriptions" element={<SubscriptionList />} />
					<Route path="/wine-clubs" element={<WineClubSubscriptions />} />
				</Routes>
			</div>
		</HashRouter>
	);
};

export default Account;
